import { Card, Flex, Progress, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

import { SoonTag } from 'src/components'

import { useStyles } from './styles'

const { Text } = Typography

type Quota = {
  key: string
  label: string
  used: number
  cap: number
  unit: string
}

// Sample plan caps — illustrative until the billing/usage endpoint ships.
const QUOTAS: Quota[] = [
  { key: 'members', label: 'Members', used: 28, cap: 50, unit: 'seats' },
  {
    key: 'signIns',
    label: 'Monthly sign-ins',
    used: 1756,
    cap: 5000,
    unit: 'this month'
  },
  {
    key: 'api',
    label: 'API requests',
    used: 184_000,
    cap: 500_000,
    unit: 'this month'
  }
]

const toneFor = (pct: number) => {
  if (pct >= 90) return 'var(--ant-color-error)'
  if (pct >= 70) return 'var(--ant-color-warning)'

  return 'var(--ant-color-primary)'
}

export const OverviewPlanUsage = () => {
  const { styles } = useStyles()
  const { t } = useTranslation()

  return (
    <Card variant="outlined" className={styles.panelCard}>
      <Flex className={styles.panelHeader}>
        <Flex align="center" gap={6}>
          <Text className={styles.panelTitle}>
            {t('workspaceOverview.planUsage.title')}
          </Text>
          <SoonTag />
        </Flex>
        <Text
          type="secondary"
          style={{ fontSize: 12, cursor: 'not-allowed' }}
          title="Available when billing is enabled"
        >
          {t('workspaceOverview.planUsage.upgrade')} →
        </Text>
      </Flex>

      <Flex vertical gap={12} style={{ padding: '14px 16px 16px' }}>
        {QUOTAS.map((quota) => {
          const pct = Math.min(100, Math.round((quota.used / quota.cap) * 100))
          const tone = toneFor(pct)

          return (
            <Flex vertical gap={4} key={quota.key}>
              <Flex justify="space-between" align="baseline">
                <Text style={{ fontSize: 12, fontWeight: 500 }}>
                  {quota.label}
                </Text>
                <Text
                  type="secondary"
                  style={{ fontSize: 11, fontVariantNumeric: 'tabular-nums' }}
                >
                  <Text strong>{quota.used.toLocaleString()}</Text> /{' '}
                  {quota.cap.toLocaleString()} {quota.unit}
                </Text>
              </Flex>
              <Progress
                percent={pct}
                showInfo={false}
                strokeColor={tone}
                size="small"
              />
            </Flex>
          )
        })}
      </Flex>
    </Card>
  )
}
